import ShopRegistrationApp from "./src/ShopRegistrationApp";
import React from 'react'
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import configureStore from "./src/store/configureStore";
import {BrowserRouter} from 'react-router-dom';

const store = configureStore();
const container = document.getElementById('shop-project');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <ShopRegistrationApp />
        </BrowserRouter>
    </Provider>
);
